module.exports = __webpack_public_path__ + "static/img/h13.1dfff9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h13.jpg
// module id = jV7q
// module chunks = 0